const menuDesserts = [
  {
    id: 1,
    name: "Traditional Baklava",
    description: [""],
    price: "$5.20",
  },
  {
    id: 2,
    name: "Armenian Rice Pudding",
    description: [""],
    price: "$5.20",
  },
];

export default menuDesserts;
